<script lang="ts">
    import { ShowState } from '../../types/Show'
    import Inactive from '../Show/Inactive.svelte'
    import Active from '../Show/Active.svelte'
    import { showStore as show } from '../../stores'
</script>

{#if $show.state === ShowState.Running || $show.state === ShowState.Ending || $show.state === ShowState.Cancelled}
    <Active on:productSelected on:bidButtonClick /> <!-- event forwarding -->
{:else}
    <Inactive on:bidButtonClick />
{/if}